<template><div><h1 id="fakturen-drucken-kopien" tabindex="-1"><a class="header-anchor" href="#fakturen-drucken-kopien"><span>Fakturen drucken, Kopien</span></a></h1>
<p>Fakturen drucken, Kopien — Druckt Kopien von bereits aufbereiteten und gedrucken Aufträgen</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>Diese Funktion druckt Kopien von Fakturen. Bedingung ist, dass die Aufbereitung der Fakturen mit dem Schritt <RouteLink to="/referenz/refs/ft.refproc.wbsdrucken.html" title="Fakturen drucken, aufbereitete">Aufbereitete Fakturen drucken</RouteLink> abgeschlossen ist (Status mindestens 5 in <RouteLink to="/referenz/refs/ft.refdata.wbsjob.html" title="Fakturen/Avis aufbereiten">Fakturen/Avis aufbereiten</RouteLink>.</p>
<h2 id="start-parameter" tabindex="-1"><a class="header-anchor" href="#start-parameter"><span>Start &amp; Parameter</span></a></h2>
<p>Pfad: Aufträge: → Verarbeitungsläufe → Fakturen/Avis verarbeiten → Fakturen/Avis aufbereiten → Menü: WBS-Kopien drucken</p>
<p><strong>Parameter</strong></p>
<dl>
<dt>Fakturanummer (von/bis)</dt>
<dd>Eingabe der Fakturanummer. Dabei ist folgendes zu berücksichtigen:
<table>
<thead>
<tr>
<th>Feld von</th>
<th>Feld bis</th>
<th>Beschreibung</th>
</tr>
</thead>
<tbody>
<tr>
<td>0</td>
<td>200123</td>
<td>Es werden die Fakturen mit der Nummer 0 bis 200123 gedruckt</td>
</tr>
<tr>
<td>200123</td>
<td>0</td>
<td>Es wird nur die Faktura 200123 gedruckt. Für den Druck einzelner Fakturen kann auch direkt im Auftrag mit der Funktion WBS (erneut) drucken ausgelöst werden.</td>
</tr>
<tr>
<td>200123</td>
<td>200125</td>
<td>Es werden die Fakturen mit der Nummer 200123 bis 200125 gedruckt</td>
</tr>
</tbody>
</table>
</dd>
<dt>Jobdatum/Lauf-Nr.</dt>
<dd>Einschränkung auf einen bestimmten Job</dd>
<dt>Komplett retournierte WBS drucken</dt>
<dd>nein (Standard) = WBS, welche zwischenzeitlich ohne physisch auszuliefernde Ware (ohne offene bzw. ausgelieferte Auftragspositionen sind) im System sind, werden nicht gedruckt</dd>
<dt>Auftragsart</dt>
<dd>Nur Kopien mit dieser auftragsart werden gedruckt</dd>
<dt>Drucker</dt>
<dd>Auswahl des Druckers (bei Standarddruck, nicht XML-Output)</dd>
<dt>Ausgabedatei</dt>
<dd>Eintrag der Druckdatei (bei Standarddruck, nicht XML-Output)</dd>
<dt>Dokumentensatz</dt>
<dd><a class="link" href="ft.refdata.do-doksatz.html" title="Dokumententensatz">Dokumentensatz</a>, worin definiert ist, wo welche Dokumente gedruckt werden. Dieses Feld ist nur aktiv, wenn in der entsprechenden Auftragsart bereits ein Dokumentensatz definiert bist.</dd>
</dl>
<h2 id="output-liste" tabindex="-1"><a class="header-anchor" href="#output-liste"><span>Output (Liste)</span></a></h2>
<p>Kopien von Fakturen</p>
<h2 id="welche-daten-werden-verwendet-input" tabindex="-1"><a class="header-anchor" href="#welche-daten-werden-verwendet-input"><span>Welche Daten werden verwendet? (Input)</span></a></h2>
<h2 id="welche-daten-werden-verandert-oder-erzeugt" tabindex="-1"><a class="header-anchor" href="#welche-daten-werden-verandert-oder-erzeugt"><span>Welche Daten werden verändert oder erzeugt?</span></a></h2>
<h2 id="siehe-auch" tabindex="-1"><a class="header-anchor" href="#siehe-auch"><span>Siehe auch</span></a></h2>
<p><RouteLink to="/referenz/refs/ft.refproc.wbsdrucken.html" title="Fakturen drucken, aufbereitete">Fakturen drucken, aufbereitete</RouteLink>, <RouteLink to="/referenz/refs/ft.refdata.wbsjob.html" title="Fakturen/Avis aufbereiten">Fakturen/Avis aufbereiten</RouteLink>, <RouteLink to="/referenz/refs/ft.refproc.wbserndruck.html" title="WBS (erneut) drucken">WBS (erneut) drucken</RouteLink>, <RouteLink to="/manual/administration/dokumentproduktion.html" title="2. Document Output">Document Output</RouteLink></p>
</div></template>


